import { Message } from 'lib-shared-legacy-types';

export type SurveyOfferState = 'Offered' | 'Cancelled' | 'Answered';

const messagesContainType = (messages: Message[], messageType: string) =>
  messages.some(({ type }) => type === messageType);

/**
 * Returns the state of the survey in case it is already triggered. Returns
 * undefined if the survey is not triggered yet, which means the survey can
 * still be cancelled by the agent if they have the necessary permissions.
 */
export function inferSurveyOfferStateFromConversationMessages(
  messages: Message[],
): SurveyOfferState | undefined {
  if (messagesContainType(messages, 'conversation:rated')) {
    return 'Answered';
  }

  if (messagesContainType(messages, 'conversation:rating_offered')) {
    return 'Offered';
  }

  if (messagesContainType(messages, 'conversation:rating_cancelled')) {
    return 'Cancelled';
  }

  return undefined;
}
